export default function(x) {
  return function constant() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-shape/src/constant.js
// module id = ../../../../d3-shape/src/constant.js
// module chunks = 3